// extracted by mini-css-extract-plugin
export default {"modelFormActions":"legacy_form-module___modelFormActions___e9585976","form":"legacy_form-module___form___dcf7921e"};